import axios from "axios";
import { login } from "./authActions";

export const getMedias = () => {
  return async (dispatch, getState) => {
    dispatch({
      type: "LOADING_START",
    });
    const token = getState().auth.token;
    const config = getState().auth.config;
    console.log(token, config, "media config");
    await axios
      .post(
        `${config.baseUrl}/media/list`,
        {
          siteId: config.adsignSiteId,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then(async (res) => {
        const data = res.data.data;
        dispatch({
          type: "GET_MEDIA",
          payload: data,
        });
      })
      .catch((err) => {
        if (err.response) {
          if (err.response.status === 401) {
            dispatch(
              login(() => {
                dispatch(getMedias());
              })
            );
          }
        }
      });

    dispatch({
      type: "LOADING_FINISH",
    });
  };
};

export const setSelectedMiscellaneous = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_SELECTED_MISCELLANEOUS",
      payload: value,
    });
  };
};
